export function parseTypeFromUrl(url: string) {
    return url.indexOf('/product') !== -1
        ? 'Product'
        : url.indexOf('/products') !== -1
            ? 'Collection'
            : 'Product'
}